import Pickr from '@simonwep/pickr';

window.Pickr = Pickr;
